import { render, staticRenderFns } from "./ClientLocationsFilter.vue?vue&type=template&id=f53da304&scoped=true&"
import script from "./ClientLocationsFilter.vue?vue&type=script&lang=js&"
export * from "./ClientLocationsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53da304",
  null
  
)

export default component.exports